import { Component, EventEmitter, Input, Output, ViewEncapsulation } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TranslateModule } from '@ngx-translate/core';

@Component({
  selector: 'lv-captioned-image',
  templateUrl: 'captioned-image.component.html',
  styleUrls: ['captioned-image.component.scss'],
  encapsulation: ViewEncapsulation.None,
  imports: [CommonModule, TranslateModule]
})
export class CaptionedImageComponent {
  @Input() src: string;
  @Input() caption: string;
  @Input() allowRetake: boolean;
  @Output() retake = new EventEmitter();
}
